<template>
  <section>
    <v-hover>
      <template v-slot="{ hover }">
        <v-card
          dark
          class="ma-2 primary"
          width="200"
          :elevation="hover ? 24 : 6"
          @click="dialogLibrary = true"
          :style="{
            top: hover ? '-6px' : '0px',
          }"
          style="position: relative; transition: all 0.3s"
        >
          <OrganismProfilePicture :id="item.id"></OrganismProfilePicture>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{
                item.vernacularName || "s/nombre común"
              }}</v-list-item-title>
              <v-list-item-subtitle
                class="caption"
                style="font-style:italic;"
                >{{
                  item.scientificName || "s/nombre científico"
                }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </template>
    </v-hover>
    <v-dialog v-model="dialogLibrary" max-width="600">
      <LibraryItem
        :id-organism="item.id"
        class="full-height"
        @onClose="dialogLibrary = false"
        :show-close-button="true"
      ></LibraryItem>
    </v-dialog>
  </section>
</template>

<script>
import OrganismGallery from "../Organism/OrganismGallery";
import LibraryItem from "../Library/LibraryItem";
import OrganismProfilePicture from "../Organism/OrganismProfilePicture";
export default {
  components: { OrganismGallery, OrganismProfilePicture, LibraryItem },
  props: ["item"],
  data: () => ({
    dialogLibrary: false,
  }),
  watch: {
    item: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      async handler(item, old) {
        this.$emit("update:item", item);
      },
    },
  },
  methods: {
    showDetails() {},
    updateAttachementList(attachementList) {
      this.item.attachementList = attachementList || [];
    },
  },
};
</script>

<style></style>
